import React, { useState } from "react";
import axios from "axios";
import useUserRole from "../../app/auth/useUserRole";
import { getToken } from "../../app/auth/authConfig";

const CategoryRegistration = () => {
  const [categoryName, setCategoryName] = useState("");
  const [categoryDesc, setCategoryDesc] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const currentUserRole = useUserRole();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      categoryName,
      description: categoryDesc,
    };

    try {
      setLoading(true);
      const baseURL = `${process.env.REACT_APP_BACKEND_API_URL}/api/categories/`;
      const token = await getToken();

      await axios.post(baseURL, payload, {
        headers: { "oidc-token": token },
      });

      setToast({ type: "success", message: "✅ Category registered successfully!" });
      setTimeout(() => setToast(null), 3000);
      handleReset();
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Category creation failed";
      setToast({ type: "error", message: `❌ ${errorMsg}` });
      setTimeout(() => setToast(null), 3000);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setCategoryName("");
    setCategoryDesc("");
  };

  return (
    <div style={{ background: "#fff", borderRadius: 12, padding: 32 }}>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", gap: 24, flexWrap: "wrap" }}
      >
        {/* Category Name */}
        <div style={{ flex: "1 1 40%" }}>
          <label style={{ fontWeight: 500, marginBottom: 8, display: "block" }}>
            Category Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            value={categoryName}
            placeholder="Enter Category Name"
            onChange={(e) => setCategoryName(e.target.value)}
            required
            disabled={loading}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 4,
              border: "1px solid #ccc",
              height: 48,
            }}
          />
        </div>

        {/* Category Description */}
        <div style={{ flex: "1 1 55%" }}>
          <label style={{ fontWeight: 500, marginBottom: 8, display: "block" }}>
            Category Description <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            placeholder="Enter Category Description"
            value={categoryDesc}
            onChange={(e) => setCategoryDesc(e.target.value)}
            required
            disabled={loading}
            style={{
              width: "100%",
              padding: 10,
              borderRadius: 4,
              border: "1px solid #ccc",
              height: 48,
            }}
          />
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 16, width: "100%" }}>
          <button
            type="button"
            onClick={handleReset}
            disabled={loading}
            style={{
              background: "#fff",
              color: "#bb1ccc",
              border: "1px solid #bb1ccc",
              padding: "8px 32px",
              fontWeight: 600,
            }}
          >
            Reset
          </button>

          <button
            type="submit"
            disabled={loading}
            style={{
              background: "#bb1ccc",
              color: "#fff",
              border: "none",
              padding: "8px 32px",
              fontWeight: 600,
            }}
          >
            {loading ? "Registering..." : "Register"}
          </button>
        </div>
      </form>

      {toast && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            padding: "16px 24px",
            borderRadius: "8px",
            background: toast.type === "success" ? "#10b981" : "#ef4444",
            color: "white",
            fontSize: "14px",
            fontWeight: "600",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            animation: "slideIn 0.3s ease",
            zIndex: 9999,
          }}
        >
          {toast.message}
        </div>
      )}

      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default CategoryRegistration;
